module.exports = __webpack_public_path__ + "resources/img/bg-career-card1@2x.7ec5b41e.jpg";